import * as storage from '../../../utils/storage';
import Button from '../../../components/Button/Button';
import Collapsible from 'react-native-collapsible';
import DateTimePicker from '@react-native-community/datetimepicker';
import Modal from 'react-native-modal';
import React, { ReactNode, useEffect, useState } from 'react';
import Show from '../../../components/Show/Show';
import _ from 'lodash';
import { ActivityIndicator, AppState, Dimensions, FlatList, KeyboardAvoidingView, LogBox, ScrollView, Switch, TouchableOpacity, View, useColorScheme } from 'react-native';
import { CHANGE_PASSWORD, DELETE_ACCOUNT_AND_DATA, SET_EVOLUTIME, UPDATE } from '../../../state/mutations/User';
import { COLORS, ERROR_COLOR } from '../../../config/designSystem/Colors';
import { Feather, FontAwesome, MaterialIcons } from '@expo/vector-icons';
import { GET_NOTIFICATION } from '../../../state/queries/User';
import { H4, ParagraphMBold, ParagraphMRegular, ParagraphSRegular } from '../../../config/designSystem/typography';
import { InfoItem } from '../../../components/Settings/DebugItem';
import { LanguagePicker } from '../../../components/ChangeLanguage/ChangeLanguage';
import { REGULAR_MARGIN_VERTICAL_FN, isAndroid, isIos, isWeb } from '../../../config/designSystem/Layout';
import { RFPercentage } from 'react-native-responsive-fontsize';
import { SPACING } from '../../../config/designSystem/Spacing';
import { STATIC_PAGES, URL } from '../../../config/config';
import { SettingStackParamList } from '../../../types/navigation';
import { StyleSheet } from 'react-native';
import { TextInput2 } from '../../../components/TextInput/TextInput2';
import { TwoButtonsHorizontal } from '../../../components/Button/TwoButtonsHorizontal';
import { addTrigger } from '../../../utils/onesignal/addTrigger';
import { captureException } from '@sentry/react-native';
import { checkPassword } from '../../../utils/others/password';
import { client } from '../../../config/apollo/client';
import { concatPath } from '../../../utils/links/concatPath';
import { helpdeskKey, libraryStackKey, pathKey, privateKey, settingStackKey, staticPageKey } from '../../../constants/routeKeys';
import { logAmplitude } from '../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { optIn } from '../../../utils/onesignal/notification';
import { removeIAMClickHandler, setIAMClickHandler } from '../../../utils/onesignal/setIAMClickHandler';
import { requestPermission } from '../../../utils/onesignal/requestPermission';
import { showMessage } from 'react-native-flash-message';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useBreakpointWidth } from '../../../hooks/useBreakpointWidth';
import { useChangeLanguage } from '../../../hooks/useChangeLanguage';
import { useFocusEffect, useGlobalSearchParams, useRouter } from 'expo-router';
import { useLogout } from '../../../hooks/authentification/useLogout';
import { useMutation } from '@apollo/client';
import { useOneSignal } from '../../../components/Root/OneSignalContext';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { usePreventScreenCaptureWhileFocused } from '../../../hooks/usePreventScreenCaptureWhileFocused';
import { useStores } from '../../../hooks/useStores';

const { height } = Dimensions.get('window');


type SettingProps = SettingStackParamList['Setting'];

export interface StatePageProps {
  name: string;
}

// Setting Card Component
interface SettingCardProps {
  icon: React.ReactNode;
  label: string;
  subtitle?: string;
  onPress: () => void;
  showArrow?: boolean;
  danger?: boolean;
  /** Shows a spinner and blocks further presses while the action is running. */
  loading?: boolean;
}

const SettingCard = ({ icon, label, subtitle, onPress, showArrow = true, danger = false, loading = false }: SettingCardProps) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={loading}
      accessibilityState={{ busy: loading, disabled: loading }}
      style={[styles.settingCard, loading && { opacity: 0.6 }]}
    >
      <View style={[styles.settingCardIcon, danger && styles.settingCardIconDanger]}>
        {icon}
      </View>
      <View style={styles.settingCardContent}>
        <ParagraphMBold color={danger ? ERROR_COLOR : COLORS.content.primary}>{label}</ParagraphMBold>
        {subtitle && <ParagraphSRegular color={COLORS.content.secondary}>{subtitle}</ParagraphSRegular>}
      </View>
      {loading && (
        <ActivityIndicator size="small" color={danger ? ERROR_COLOR : COLORS.content.tertiary} />
      )}
      {!loading && showArrow && (
        <Feather name="chevron-right" size={20} color={COLORS.content.tertiary} />
      )}
    </TouchableOpacity>
  );
};

// Section Header Component
interface SectionHeaderProps {
  title: string;
  icon?: React.ReactNode;
}

const SectionHeader = ({ title, icon }: SectionHeaderProps) => {
  return (
    <View style={styles.sectionHeader}>
      {icon}
      <H4 color={COLORS.content.secondary}>{title}</H4>
    </View>
  );
};

// Section Container Component
interface SectionContainerProps {
  children: React.ReactNode;
}

const SectionContainer = ({ children }: SectionContainerProps) => {
  return (
    <View style={styles.sectionContainer}>
      {children}
    </View>
  );
};

const Setting: React.FunctionComponent<SettingProps> = observer(() => {
  const rootStore = useStores();
  const router = useRouter();
  const params = useGlobalSearchParams();
  const insets = useSafeAreaInsets();

  const [isModalVisible, setModalVisible] = React.useState(false);
  const [isModalPasswordVisible, setModalPasswordVisible] = React.useState(false);
  const [isModalLanguageVisible, setModalLanguageVisible] = React.useState(false);
  const [isModalDeletionVisible, setModalDeletionVisible] = React.useState(false);
  const [isModalNotificationVisible, setModalNotificationVisible] = React.useState(false);
  const [modalNotifAlreadyForced, setModalNotifAlreadyForced] = React.useState(false);

  const [nameValue, onChangeTextName] = React.useState('');
  const [changeNameStatus, setchangeNameStatus] = React.useState('unset');
  const nameInputRef = React.useRef(null);

  const formatDaysOfWeek = (days: any[]): any[] => {
    return days.map((day, index) => ({ id: String(index), value: day }));
  };

  const unformatDaysOfWeek = (days: any[]): any[] => {
    return days.map(day => day.value);
  };

  const [daysOfWeek, setDaysOfWeek] = React.useState(
    formatDaysOfWeek([false, false, false, false, false, false, false]),
  );
  const [hour, setHour] = React.useState(0);
  const [minute, setMinute] = React.useState(0);
  const [showTime, setShowTime] = React.useState(false);
  const [timeIos, setTimeIos] = React.useState(false);
  const [daysCollapsed, setDaysCollapsed] = React.useState(false);
  const [time, setTime] = React.useState(new Date());

  const [oldPasswordValue, onChangeOldPassword] = React.useState('');
  const [newPasswordValue, onChangeNewPassword] = React.useState('');
  const oldPasswordInputRef = React.useRef(null);
  const newPasswordInputRef = React.useRef(null);
  const [changePasswordStatus, setchangePasswordStatus] = React.useState('unset');
  const [errorPasswordMessage, setErrorPasswordMessage] = React.useState('error');

  const [languageValue, onChangeLanguage] = React.useState('');

  const [askFetchNotif, setAskFetchNotif] = React.useState(true);

  const [forceHiding, setForceHiding] = useState(false);
  const appState = React.useRef(AppState.currentState);
  const [appStateVisible, setAppStateVisible] = useState(appState.current);

  const { width, height } = useAvailableDimensions();
  const { isInitialized } = useOneSignal();
  const [updateEvolutime, { loading: evolutimeLoading, error: evolutimeError }] = useMutation(SET_EVOLUTIME,
    { fetchPolicy: 'no-cache' });

  usePreventScreenCaptureWhileFocused();

  const labels = rootStore?.language?.translate?.MOBILE?.SETTINGS;
  const isDarkMode = useColorScheme() === 'dark';

  const changeLanguage = useChangeLanguage();

  const getNotification = async () => {
    const { data } = await client.query({ query: GET_NOTIFICATION, fetchPolicy: 'no-cache' });
    handelEvolutime(data);
  };

  useEffect(() => {
    if (askFetchNotif) {
      getNotification();
      setAskFetchNotif(false);
    }
  }, [askFetchNotif]);

  useEffect(() => {
    if (isInitialized) {
      const listener = setIAMClickHandler(value => {
        if (value === 'refuse_notif') {
          setModalNotificationVisible(false);
          showMessage({
            message: labels.NOTIFICATION?.NO_PERMISSION
              ? labels.NOTIFICATION?.NO_PERMISSION
              : 'You need to switch on the permission.',
            type: 'danger',
            duration: 5000,
          });
        }
      });

      return () => {
        removeIAMClickHandler(listener);
      };
    }
  }, [isInitialized]);

  React.useEffect(() => {
    const subscription = AppState.addEventListener('change', nextAppState => {
      appState.current = nextAppState;
      setAppStateVisible(appState.current);
    });
    return () => {
      subscription.remove();
    };
  }, []);

  React.useEffect(() => {
    setForceHiding(appStateVisible !== 'active');
  }, [appStateVisible]);

  React.useEffect(() => {
    setchangeNameStatus('unset');
  }, [nameValue]);

  React.useEffect(() => {
    LogBox.ignoreLogs(['VirtualizedLists should never be nested']);
  }, []);

  useFocusEffect(() => {
    if (params.notif === 'true' && !modalNotifAlreadyForced) {
      setModalNotificationVisible(true);
      setModalNotifAlreadyForced(true);
    }
  });

  useEffect(() => {
    if (isModalNotificationVisible) {
      promptMeIfNotAllowed();
    }
  }, [isModalNotificationVisible]);

  const handelEvolutime = (data: any) => {
    if (data?.getMyProfile?.evolutime && 'active' in data.getMyProfile.evolutime) {
      setDaysOfWeek(formatDaysOfWeek(data.getMyProfile.evolutime.daysOfWeek));
      setHour(data.getMyProfile.evolutime.hour);
      setMinute(data.getMyProfile.evolutime.minute);
      const time2 = time;
      time2.setHours(data.getMyProfile.evolutime.hour);
      time2.setMinutes(data.getMyProfile.evolutime.minute);
      setTime(time2);
    } else {
      setDaysOfWeek(formatDaysOfWeek([false, false, false, false, false, false, false]));
      setHour(0);
      setMinute(0);
      setTime(new Date());
    }
  };

  const promptMeIfNotAllowed = async () => {
    const deviceState = await requestPermission();
    if (deviceState) {
      addTrigger('prompt_me_notification_permission', rootStore?.language?.name.key);
    }
  };

  const openModalNotif = async (): Promise<void> => {
    setModalNotificationVisible(!isModalNotificationVisible);
    setShowTime(false);
  };

  const cbLogout = () => {
    logAmplitude('Logout');
    rootStore?.onboarding.set(false);
  };

  const logout = useLogout(cbLogout);
  const [isLoggingOut, setLoggingOut] = useState(false);

  // Logout is no longer instant: it closes any open WPO video request first, and that
  // is a round trip to WPO (capped at 5s). Without feedback the row just looks dead,
  // so show a spinner and swallow repeat presses -- firing logout twice would race the
  // close call against its own token removal.
  const handleLogout = async () => {
    if (isLoggingOut) {
      return;
    }
    setLoggingOut(true);
    try {
      await logout();
    } finally {
      setLoggingOut(false);
    }
  };

  const handleNextPassword = async () => {
    if (oldPasswordInputRef !== null) {
      newPasswordInputRef.current.focus();
    }
  };

  const redirectToPath = async (): Promise<void> => {
    if (params.redirectToPath) {
      router.replace({
        pathname: concatPath([libraryStackKey, pathKey]) as string,
        params: {
          id: params.redirectToPath,
        }
      });
    }
  };

  const askDeletion = async (): Promise<void> => {
    try {
      const { data } = (await client.mutate({
        mutation: DELETE_ACCOUNT_AND_DATA,
        fetchPolicy: 'no-cache',
      })) as any;
      if (!data.deleteAccountAndData) {
        throw new Error('could not send the deletion request');
      }
      setModalDeletionVisible(!isModalDeletionVisible);
      showMessage({
        message: labels.DELETION_DONE ? labels.DELETION_DONE : 'Thank you for your feedback.',
        type: 'success',
        style: { backgroundColor: COLORS.state.success.primary },
        duration: 5000,
      });
      logAmplitude('Deletion Succeeded');
      logout();
    } catch (error) {
      showMessage({
        message: labels.DELETION_ERROR ? labels.DELETION_ERROR : 'Could not sent the request. Please retry.',
        type: 'danger',
        duration: 5000,
      });
      logAmplitude('Deletion Failed');
    }
  };

  const changeName = async (): Promise<void> => {
    setchangeNameStatus('pending');

    if (nameValue === '') {
      setchangeNameStatus('notCompletedField');
    } else {
      try {
        const inputt = { _id: rootStore?.user.getUser._id, firstName: nameValue, email: rootStore?.user.getUser.email };
        const { data } = (await client.mutate({
          mutation: UPDATE,
          fetchPolicy: 'no-cache',
          variables: {
            input: inputt,
          },
        })) as any;
        const userData = _.cloneDeep(rootStore?.user.user);
        userData.firstName = data.updateUser.firstName;
        rootStore?.user.set(userData);
        setchangeNameStatus('done');
        setModalVisible(!isModalVisible);
      } catch (error) {
        setchangeNameStatus('error');
      }
    }
  };

  const changeNotification = async (): Promise<void> => {
    try {
      const newEvolutime = await updateEvolutime({
        variables: {
          active: true,
          daysOfWeek: unformatDaysOfWeek(daysOfWeek),
          hour,
          minute,
        },
      });
      optIn();
      if (newEvolutime && newEvolutime.data) {
        setDaysOfWeek(formatDaysOfWeek(newEvolutime.data.setEvolutime.daysOfWeek));
        setHour(newEvolutime.data.setEvolutime.hour);
        setMinute(newEvolutime.data.setEvolutime.minute);
        const time2 = time;
        time2.setHours(newEvolutime.data.setEvolutime.hour);
        time2.setMinutes(newEvolutime.data.setEvolutime.minute);
        setTime(time2);
        showMessage({
          message: labels.NOTIFICATION?.FLASH_SUCCESS ? labels.NOTIFICATION?.FLASH_SUCCESS : 'Changement sauvegardé',
          type: 'success',
          style: { backgroundColor: COLORS.state.success.primary },
          duration: 5000,
        });
        logAmplitude('Notification Settings Changed', {
          active: newEvolutime.data.setEvolutime.active,
        });
      } else if (evolutimeError) {
        throw new Error('Can not modify evolutime');
      }
    } catch (error) {
      showMessage({
        message: labels.NOTIFICATION?.FLASH_FAIL ? labels.NOTIFICATION?.FLASH_FAIL : 'Merci de réessayer',
        type: 'danger',
        duration: 5000,
      });
      logAmplitude('Notification Settings Changes Failed');
    }
  };

  const setErrorPassword = (statusIfOk: string, oldP?: string, newP?: string) => {
    const oldpass: string = oldP ? oldP : oldPasswordValue;
    const newpass: string = newP ? newP : newPasswordValue;
    if (!checkPassword(newpass)) {
      setErrorPasswordMessage(labels.PASSWORD_REQUIREMEND);
      setchangePasswordStatus('error');
      return false;
    } else {
      setchangePasswordStatus(statusIfOk);
      setErrorPasswordMessage('');
      return true;
    }
  };

  React.useCallback(() => {
    setErrorPassword('unset');
  }, [oldPasswordValue, newPasswordValue]);

  const changePassword = async (): Promise<void> => {
    if (await setErrorPassword('pending')) {
      try {
        await client.mutate({
          mutation: CHANGE_PASSWORD,
          fetchPolicy: 'no-cache',
          variables: {
            oldPassword: oldPasswordValue,
            newPassword: newPasswordValue,
          },
        });
        showMessage({
          message: labels.PASSWORD_CHANGED ? labels.PASSWORD_CHANGED : 'Mot de passe changé',
          type: 'success',
          style: { backgroundColor: COLORS.state.success.primary },
          duration: 5000,
        });
        setModalPasswordVisible(!isModalPasswordVisible);
        setchangePasswordStatus('done');
        logAmplitude('Password Changed');
      } catch (error) {
        console.log('error', error);
        setchangePasswordStatus('error');
        setErrorPasswordMessage(labels?.PASSWORD_ERROR);
        logAmplitude('Password Change Failed');
      }
    }
  };

  const renderDayOfWeek = React.useCallback(
    ({ item, index }) => {
      return (
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <ParagraphMRegular selectable={true} >
            {labels.NOTIFICATION?.DAYSOFWEEK['DAY' + index]}
          </ParagraphMRegular>
          <Switch
            style={{ transform: [{ scaleX: 0.6 }, { scaleY: 0.6 }], alignSelf: 'center', marginBottom: 5 }}
            trackColor={{ false: '#767577', true: COLORS.brand[500] }}
            thumbColor={item.value ? '#22444d' : '#f4f3f4'}
            ios_backgroundColor="#3e3e3e"
            onValueChange={val => {
              const a = [...daysOfWeek];
              a[index] = { id: String(index), value: val };
              setDaysOfWeek(a);
            }}
            value={item.value}
          />
        </View>
      );
    },
    [daysOfWeek],
  );

  let firstName = '';

  try {
    firstName = rootStore?.user?.getUser?.firstName;
  } catch (error) {
    captureException(error);
  }

  const onPressHelp = () => {
    router.navigate(concatPath([helpdeskKey], 0));
  };

  const BASIC_WIDTH_INPUT = useBreakpointWidth({ sm: width * 0.8, md: width * 0.6, lg: width * 0.4 });
  const LANGUAGE_WIDTH_INPUT = useBreakpointWidth({ sm: width * 0.8, md: width * 0.6, lg: width * 0.4 });
  const MIN_VALUE = isWeb ? 500 : 150;
  const MARGIN = useBreakpointWidth({ sm: 10, md: 50, lg: 100 });
  const WIDTH_MODAL = Math.min(0.9 * width, Math.max(MIN_VALUE, BASIC_WIDTH_INPUT + MARGIN));

  const modalWrapper = (child: ReactNode, isVisible: boolean, onPressCancel: () => void, onPressValidate: () => void, withButtons = true) => {
    const mainChildren = () => {
      return (
        <View
          style={{
            alignItems: 'center',
            backgroundColor: 'white',
            padding: 20,
            borderRadius: SPACING['sp-16'],
            maxWidth: WIDTH_MODAL,
            justifyContent: 'center'
          }} >
          {child}
          {withButtons ? (
            <View style={{ marginTop: 30 }}>
              <TwoButtonsHorizontal onPressLeft={onPressCancel}
                onPressRight={onPressValidate}
                labelLeft={labels.CANCEL}
                labelRight={labels.VALIDATE}
                smallText={true}
                paddingVertical={15}
                width={WIDTH_MODAL}
              />
            </View>) : null}
        </View>);
    };
    return (
      <View >
        <Modal
          isVisible={isVisible}
          style={{ flex: 1 }}
        >
          <View style={{ alignItems: 'center', justifyContent: 'center', flex: 1 }}>
            {isIos ? (
              <KeyboardAvoidingView
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  maxWidth: WIDTH_MODAL,
                  marginBottom: 30
                }} behavior="position">
                {mainChildren()}
              </KeyboardAvoidingView>) : (<>
              {mainChildren()}
            </>)}
          </View>
        </Modal>
      </View>);
  };

  const modalName = () => {
    const child = (<>
      <TextInput2
        label={''}
        value={nameValue}
        textContentType="givenName"
        returnKeyType="done"
        secured={false}
        image="user"
        reference={nameInputRef}
        onChangeText={(text: string) => onChangeTextName(text)}
        onSubmitEditing={() => { }}
        autoFocus={true}
        marginTop={REGULAR_MARGIN_VERTICAL_FN(height)}
        widthInput={BASIC_WIDTH_INPUT}
      />
      {changeNameStatus === 'error' && (
        <View style={{ marginTop: 10 }}>
          <ParagraphSRegular align={true} color={ERROR_COLOR}>
            {labels.NAME_ERROR}
          </ParagraphSRegular>
        </View>
      )}
    </>);
    return (
      <>
        {modalWrapper(child, isModalVisible, () => {
          setModalVisible(!isModalVisible);
        },
        () => {
          changeName();
        })}
      </>
    );
  };

  const modalNotification = () => {
    const child = (<ScrollView horizontal={false} style={{ maxHeight: 0.8 * height, width: WIDTH_MODAL }}>
      <>
        {(!timeIos || isAndroid) && (
          <View style={{ marginVertical: 10, marginHorizontal: 20 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 }}>
              <H4 selectable={false}>
                {labels.NOTIFICATION?.ALLOW}
              </H4>
            </View>
            <View>
              <ParagraphMRegular selectable={false}>
                {labels.NOTIFICATION?.EXPLANATION
                  ? labels.NOTIFICATION?.EXPLANATION
                  : 'You may then choose your favorite times and days to improve yourself.'}
              </ParagraphMRegular>
            </View>
            <View>
              <View style={{ marginBottom: 15, marginTop: 15 }}>
                <TouchableOpacity
                  onPress={() => {
                    setDaysCollapsed(!daysCollapsed);
                  }}
                  style={{
                    backgroundColor: '#F7F7F7',
                    paddingHorizontal: 15,
                    paddingVertical: 10,
                    borderRadius: 6,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <ParagraphMBold>
                    {labels.NOTIFICATION?.SHOW_DAYS_OF_WEEK
                      ? labels.NOTIFICATION?.SHOW_DAYS_OF_WEEK
                      : 'Jours de la semaine'}
                  </ParagraphMBold>
                  <FontAwesome name={daysCollapsed ? 'chevron-down' : 'chevron-up'} size={18} />
                </TouchableOpacity>
                <Collapsible collapsed={daysCollapsed} collapsedHeight={0}>
                  <ScrollView style={{ marginLeft: 30, maxHeight: RFPercentage(40), paddingTop: 10 }}>
                    <FlatList
                      data={daysOfWeek}
                      renderItem={renderDayOfWeek}
                      contentContainerStyle={styles.scrollContainer}
                      keyExtractor={item => item.id}
                    />
                  </ScrollView>
                </Collapsible>
              </View>
              <View style={{ marginBottom: 15, marginTop: 15 }}>
                <TouchableOpacity
                  onPress={() => {
                    setShowTime(true);
                    setTimeIos(true);
                  }}
                  style={{
                    backgroundColor: '#F7F7F7',
                    paddingHorizontal: 15,
                    paddingVertical: 10,
                    borderRadius: 6,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <ParagraphMBold>
                    {labels.NOTIFICATION?.TIME_PICKER ? labels.NOTIFICATION?.TIME_PICKER : 'Heure:'} {hour}:
                    {minute < 10 ? '0' + minute : minute}
                  </ParagraphMBold>
                  <MaterialIcons name="access-time" size={24} />
                </TouchableOpacity>
              </View>

              {showTime && isAndroid ? (
                <DateTimePicker
                  testID="timePickerAndroid"
                  value={time}
                  mode="time"
                  is24Hour={true}
                  display="default"
                  onChange={(event, value) => {
                    setShowTime(false);
                    if (value) {
                      setHour(value.getHours());
                      setMinute(value.getMinutes());
                      const time2 = time;
                      time2.setHours(value.getHours());
                      time2.setMinutes(value.getMinutes());
                      setTime(time2);
                    }
                  }}
                  locale={rootStore?.language?.name.key}
                />
              ) : null}
            </View>
            <View style={{ alignItems: 'center' }}>
              <TwoButtonsHorizontal
                onPressLeft={() => {
                  setShowTime(false);
                  setModalNotificationVisible(!isModalNotificationVisible);
                  setAskFetchNotif(true);
                  redirectToPath();
                }}
                onPressRight={() => {
                  setShowTime(false);
                  changeNotification();
                  setModalNotificationVisible(!isModalNotificationVisible);
                  redirectToPath();
                  storage.saveString('setNotification', 'false');
                }}
                labelLeft={labels.CANCEL}
                labelRight={labels.VALIDATE}
                smallText={true}
                paddingVertical={15}
                width={WIDTH_MODAL} />
            </View>
          </View>
        )}
        {timeIos && isIos && (
          <View style={{ alignItems: 'center' }}>
            <DateTimePicker
              style={{ backgroundColor: isDarkMode ? '#000' : '#fff' }}
              testID="timePickerIos"
              value={time}
              mode="time"
              display="spinner"
              onChange={(event, value) => {
                if (value) {
                  setHour(value.getHours());
                  setMinute(value.getMinutes());
                  const time2 = _.cloneDeep(time);
                  time2.setHours(value.getHours());
                  time2.setMinutes(value.getMinutes());
                  setTime(time2);
                }
              }}
              locale={rootStore?.language?.name.key}
            />
            <Button onPress={() => {
              setTimeIos(false);
            }} label={labels.VALIDATE} smallText={true} width={WIDTH_MODAL} />
          </View>
        )}
      </></ScrollView>);
    return (<>{modalWrapper(child, isModalNotificationVisible, () => { }, () => { }, false)}</>);
  };

  const modalDeletion = () => {
    const child = (<View style={{ marginVertical: 30, marginHorizontal: 20 }}>
      <ParagraphMBold color={ERROR_COLOR}>
        {labels?.WARNING_BEFORE_DELETION}
      </ParagraphMBold>
    </View>
    );
    return (<>{
      modalWrapper(child, isModalDeletionVisible, () => {
        setModalDeletionVisible(!isModalDeletionVisible);
      }, () => { askDeletion(); })}</>);
  };

  const modalPassword = () => {
    const child = (<>
      <TextInput2
        label={labels?.OLD_PASSWORD}
        value={oldPasswordValue}
        textContentType="password"
        returnKeyType="next"
        secured={true}
        reference={oldPasswordInputRef}
        onChangeText={(text: string) => onChangeOldPassword(text)}
        onSubmitEditing={() => {
          handleNextPassword();
        }}
        autoFocus={true}
        marginTop={REGULAR_MARGIN_VERTICAL_FN(height)}
        widthInput={BASIC_WIDTH_INPUT}
        image="lock"
        forceHiding={forceHiding}
        marginRight={20}
      />
      <TextInput2
        label={labels?.NEW_PASSWORD}
        value={newPasswordValue}
        textContentType="newPassword"
        returnKeyType="done"
        secured={true}
        reference={newPasswordInputRef}
        onChangeText={(text: string) => onChangeNewPassword(text)}
        marginTop={REGULAR_MARGIN_VERTICAL_FN(height)}
        widthInput={BASIC_WIDTH_INPUT}
        image="lock"
        forceHiding={forceHiding}
        marginRight={20}
      />
      {changePasswordStatus === 'error' && (
        <ParagraphSRegular color={ERROR_COLOR}>{errorPasswordMessage}</ParagraphSRegular>
      )}</>);
    return (<>
      {modalWrapper(child, isModalPasswordVisible, () => {
        onChangeNewPassword('');
        onChangeOldPassword('');
        setchangePasswordStatus('unset');
        setModalPasswordVisible(!isModalPasswordVisible);
      }, changePassword)}</>);
  };

  const modalLanguage = () => {
    const child = (
      <LanguagePicker language={languageValue} changeLanguage={onChangeLanguage} width={LANGUAGE_WIDTH_INPUT} />
    );

    return (<>
      {modalWrapper(child, isModalLanguageVisible, () => {
        setModalLanguageVisible(!isModalLanguageVisible);
      }, () => {
        changeLanguage(languageValue);
        setModalLanguageVisible(!isModalLanguageVisible);
      })}
    </>);
  };

  return (
    <View style={[styles.container, { paddingTop: insets.top + SPACING['sp-16'] }]}>
      {/* Modals */}
      {modalNotification()}
      {modalName()}
      {modalPassword()}
      {modalLanguage()}
      {modalDeletion()}

      <ScrollView
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {/* Profile Section */}
        <SectionHeader
          title={labels?.SECTION_PROFILE || 'Profile'}
          icon={<Feather name="user" size={18} color={COLORS.content.secondary} style={{ marginRight: 8 }} />}
        />
        <SectionContainer>
          <SettingCard
            icon={<Feather name="edit-3" size={20} color={COLORS.brand[500]} />}
            label={labels?.NAME || 'Name'}
            subtitle={firstName || ''}
            onPress={() => {
              onChangeTextName(rootStore?.user?.getUser?.firstName);
              setModalVisible(!isModalVisible);
            }}
          />
          <SettingCard
            icon={<Feather name="lock" size={20} color={COLORS.brand[500]} />}
            label={labels?.CHANGE_PASSWORD || 'Change Password'}
            onPress={() => setModalPasswordVisible(!isModalPasswordVisible)}
          />
          <SettingCard
            icon={<Feather name="globe" size={20} color={COLORS.brand[500]} />}
            label={labels?.CHANGE_LANGUAGE || 'Language'}
            subtitle={rootStore?.language?.name?.name || ''}
            onPress={() => {
              onChangeLanguage(rootStore?.language?.name.key);
              setModalLanguageVisible(!isModalLanguageVisible);
            }}
          />
        </SectionContainer>

        {/* Notifications Section - Mobile only */}
        {!isWeb && (
          <>
            <SectionHeader
              title={labels?.SECTION_NOTIFICATIONS || 'Notifications'}
              icon={<Feather name="bell" size={18} color={COLORS.content.secondary} style={{ marginRight: 8 }} />}
            />
            <SectionContainer>
              <SettingCard
                icon={<Feather name="bell" size={20} color={COLORS.brand[500]} />}
                label={labels?.NOTIFICATION?.TITLE || 'Notifications'}
                onPress={openModalNotif}
              />
            </SectionContainer>
          </>
        )}

        {/* Legal Section */}
        {STATIC_PAGES.length > 0 && (
          <>
            <SectionHeader
              title={labels?.SECTION_LEGAL || 'Legal'}
              icon={<Feather name="file-text" size={18} color={COLORS.content.secondary} style={{ marginRight: 8 }} />}
            />
            <SectionContainer>
              {STATIC_PAGES.map(page => {
                const accessor = page.replace(/-/g, '_').toUpperCase();
                return (
                  <SettingCard
                    key={'item_' + accessor}
                    icon={<Feather name="file" size={20} color={COLORS.brand[500]} />}
                    label={labels?.STATIC_PAGE && accessor in labels.STATIC_PAGE ? labels?.STATIC_PAGE[accessor] : page}
                    onPress={() => {
                      router.navigate({
                        pathname: concatPath([privateKey, settingStackKey, staticPageKey], -1) as string,
                        params: { name: page }
                      });
                    }}
                    showArrow={false}
                  />
                );
              })}
            </SectionContainer>
          </>
        )}

        {/* Support Section */}
        <SectionHeader
          title={labels?.SECTION_SUPPORT || 'Support'}
          icon={<Feather name="help-circle" size={18} color={COLORS.content.secondary} style={{ marginRight: 8 }} />}
        />
        <SectionContainer>
          <SettingCard
            icon={<Feather name="message-circle" size={20} color={COLORS.brand[500]} />}
            label={labels?.SEND_FEEDBACK || 'Send Feedback'}
            onPress={onPressHelp}
          />
        </SectionContainer>

        {/* Danger Zone */}
        <SectionHeader
          title={labels?.SECTION_DANGER || 'Danger Zone'}
          icon={<Feather name="alert-triangle" size={18} color={ERROR_COLOR} style={{ marginRight: 8 }} />}
        />
        <SectionContainer>
          <SettingCard
            icon={<Feather name="trash-2" size={20} color={ERROR_COLOR} />}
            label={labels?.DELETE_ACCOUNT_OR_DATA || 'Delete Account'}
            onPress={() => setModalDeletionVisible(!isModalDeletionVisible)}
            danger={true}
          />
          <SettingCard
            icon={<Feather name="log-out" size={20} color={ERROR_COLOR} />}
            label={labels?.LOGOUT || 'Logout'}
            onPress={handleLogout}
            loading={isLoggingOut}
            showArrow={false}
            danger={true}
          />
        </SectionContainer>

        {/* Debug Info */}
        <Show when={process.env.EXPO_PUBLIC_TEST === 'true'}>
          <SectionHeader title="Debug" />
          <SectionContainer>
            <InfoItem name={'API'} value={URL} />
            <InfoItem name={'Role'} value={rootStore.user.user?.role} />
          </SectionContainer>
        </Show>

        {/* Bottom spacing */}
        <View style={{ height: SPACING['sp-100'] }} />
      </ScrollView>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLORS.surface.primary,
  },
  scrollContent: {
    paddingHorizontal: SPACING['sp-20'],
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: SPACING['sp-24'],
    marginBottom: SPACING['sp-12'],
    paddingHorizontal: SPACING['sp-4'],
  },
  sectionContainer: {
    backgroundColor: COLORS.surface.contrast,
    borderRadius: SPACING['sp-16'],
    overflow: 'hidden',
    shadowColor: COLORS.brand[500],
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 2,
  },
  settingCard: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: SPACING['sp-16'],
    paddingHorizontal: SPACING['sp-16'],
    borderBottomWidth: 1,
    borderBottomColor: COLORS.surface.secondary,
  },
  settingCardIcon: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: COLORS.surface.secondary,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: SPACING['sp-12'],
  },
  settingCardIconDanger: {
    backgroundColor: '#FEE2E2',
  },
  settingCardContent: {
    flex: 1,
  },
  scrollContainer: { paddingBottom: 15 },
});

export default Setting;
